import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export function ControlBar({ visible, isVideo, children, onMouseEnter, onMouseLeave }) {
    return (_jsx("div", { className: `hekate-player-controls ${visible ? '' : 'hekate-player-controls--hidden'}`, role: "toolbar", "aria-label": isVideo ? 'Video controls' : 'Audio controls', onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, children: children }));
}
